<template>
    <div class="searchBox w100p" data-note="虚拟搜索框，点击后跳转到搜索页。" @click="onClick">
        <div class="inner">
            <!-- 输入框部分 -->
            <div class="searchIndex search" style="height:36px;line-height:36px; padding: 0 19px;">

                <i class="icon lightGreySearchIcon2" style="width:12px;height:12px; margin-right: 8px; margin-top: 12px;"></i>
                <div class="textFont flexItem grey">{{placeholder}}</div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "searchBox",
    props: {
        placeholder : {
            type : String,
            default : '幼儿技能学习课程'
        },
        onClick: Function
    }
}
</script>

<style lang="scss" scoped>
.grey {
    color: hsla(219, 16%, 60%, 1);
}
.searchIndex{
    display: flex;
    justify-content: center;

}

.textFont{
    line-height: 36px;
    font-size: 12px;

    font-weight: 500;

}


.searchBox {
    .inner {
        height: 36px;
    }
    .search {
        background: #f6f6f6;
        border-radius: 18px;
    }
}
</style>
